<div class="submissions-tab">
  <div class="status-pills display-flex gap-8">
    <button type="button" class="pill-button" [class.active]="statusFilter() === 'pending'" (click)="setStatusFilter('pending')">Pending</button>
    <button type="button" class="pill-button" [class.active]="statusFilter() === 'all'" (click)="setStatusFilter('all')">All</button>
  </div>

  @if (submissions.isLoading()) {
    <p class="regular-14 margin-top-16">{{ 'loading' | transloco }}</p>
  } @else if (!submissions.value().length) {
    <p class="regular-14 margin-top-16">{{ 'noResultsFound' | transloco }}</p>
  } @else {
    <div class="display-flex vertical gap-12 margin-top-16">
      @for (submission of submissions.value(); track submission.id) {
        <div class="submission-row display-flex gap-12">
          <img class="submission-thumb" [src]="submission.imageUrl" [alt]="submission.name.en" />
          <div class="submission-info display-flex vertical gap-4">
            <span class="semibold-14">{{ submission.username }}</span>
            <span class="regular-14">{{ submission.name.en }}</span>
            <span class="regular-14 color-soft-grey">{{ submission.createdAt | date }}</span>
          </div>
          <span class="regular-14 status-cell" [class]="statusClass(submission)">
            {{ submission.status }}
            @if (submission.status === 'rejected' && submission.rejectReason) {
              &middot; {{ submission.rejectReason }}
            }
          </span>
          @if (submission.status === 'pending') {
            <button type="button" class="secondary-bar-btn" (click)="openReview(submission)">{{ 'cardsAdminReview' | transloco }}</button>
          }
        </div>
      }
    </div>
  }

  @if (showReviewModal()) {
    <app-modal
      [title]="'cardsAdminReview' | transloco"
      [size]="'medium'"
      [footerButtons]="reviewModalButtons"
      (closeEvent)="closeReview()">
      @if (selectedSubmission(); as submission) {
        <img class="submission-full-image" [src]="submission.imageUrl" [alt]="submission.name.en" />
        <p class="regular-14 color-soft-grey margin-top-12">{{ submission.username }}</p>
        <input type="text" class="text-input margin-top-12" [formControl]="nameEnControl" [placeholder]="'cardsAdminNameEn' | transloco" />
        <input type="text" class="text-input margin-top-12" [formControl]="nameUkControl" [placeholder]="'cardsAdminNameUk' | transloco" />
        <input type="text" class="text-input margin-top-12" [formControl]="quoteEnControl" [placeholder]="'cardsAdminQuoteEn' | transloco" />
        <input type="text" class="text-input margin-top-12" [formControl]="quoteUkControl" [placeholder]="'cardsAdminQuoteUk' | transloco" />
        <input type="text" class="text-input margin-top-12" [formControl]="reasonControl" [placeholder]="'cardsAdminRejectReason' | transloco" />
      }
    </app-modal>
  }
</div>
